import React from 'react';
import styles from './index.module.scss';
import { formatBoldTextHTML } from '../../../../utils/formatBoldText';

const PublicationCardDescriptionV1 = ({
  contentText,
  contentTag,
  contentName,
  maxLength = 500,
}) => {
  if (!contentText || contentText === 'none') {
    return null;
  }

  // Обрезаем текст если он превышает максимальную длину
  const isTruncated = contentText.length > maxLength;
  const truncatedText = isTruncated
    ? contentText.substring(0, maxLength).trim() + '...'
    : contentText;

  return (
    <div className={styles.publicationDescriptionV1}>
      <div className={styles.contentText}>
        <p dangerouslySetInnerHTML={{ __html: formatBoldTextHTML(truncatedText) }} />
      </div>
    </div>
  );
};

export default PublicationCardDescriptionV1;
